/* KHRL Cart — no drawer: icon pop + adjacent toast on ATC + free-shipping bar */
(function () {
  'use strict';

  var FREE_SHIP_THRESHOLD = 49900; /* ₹499 in paise */

  /* ── Suppress cart drawer (keep AJAX data layer, kill the slide-out) ── */
  var _drawer = document.querySelector('cart-drawer');
  if (_drawer) _drawer.open = function () {};

  /* ── Restore cart icon navigation ──
     Dawn's cart.js adds a bubble-phase click listener to #cart-icon-bubble that
     calls e.preventDefault() before opening the drawer. With open() no-op'd the
     click is swallowed entirely. We intercept in capture phase (runs before any
     bubble handler) and navigate to the cart URL ourselves. */
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('#cart-icon-bubble');
    if (!cartLink) return;
    e.stopImmediatePropagation(); /* blocks Dawn's preventDefault + open() call */
    window.location.href = cartLink.href;
  }, true /* capture */);

  /* ── Animate cart icon ── */
  function animateCartIcon() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('khrl-cart-pop');
    void icon.offsetWidth; /* force reflow to restart animation */
    icon.classList.add('khrl-cart-pop');
    icon.addEventListener('animationend', function () {
      icon.classList.remove('khrl-cart-pop');
    }, { once: true });
  }

  /* ── Update cart count badge ── */
  function updateBadge(count) {
    var badge   = document.getElementById('khrl-cart-badge');
    var countEl = document.getElementById('khrl-cart-count');
    var countSr = document.getElementById('khrl-cart-count-sr');
    var icon    = document.getElementById('cart-icon-bubble');
    if (!badge) return;

    var wasHidden = badge.classList.contains('khrl-hidden');

    if (!count || count < 1) {
      badge.classList.add('khrl-hidden');
      badge.classList.remove('khrl-badge-in');
    } else {
      badge.classList.remove('khrl-hidden');
      if (countEl) countEl.textContent = count < 100 ? count : '99+';
      if (countSr) countSr.textContent = count + (count === 1 ? ' item' : ' items') + ' in cart';
      if (wasHidden) {
        badge.classList.remove('khrl-badge-in');
        void badge.offsetWidth;
        badge.classList.add('khrl-badge-in');
        badge.addEventListener('animationend', function () {
          badge.classList.remove('khrl-badge-in');
        }, { once: true });
      }
    }

    if (icon) {
      icon.setAttribute('aria-label', count > 0
        ? 'Cart, ' + count + (count === 1 ? ' item' : ' items')
        : 'Cart');
    }
  }

  /* ── Cart-adjacent toast ── */
  var _toastEl  = null;
  var _toastTmr = null;

  function showCartToast(msg) {
    if (!_toastEl) _toastEl = document.querySelector('.khrl-cart-toast');
    var el = _toastEl;
    if (!el) return;

    /* Anchor toast just below the cart icon */
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) {
      var rect = icon.getBoundingClientRect();
      el.style.top   = (rect.bottom + 8) + 'px';
      el.style.right = Math.max(window.innerWidth - rect.right, 8) + 'px';
      el.style.left  = 'auto';
    }

    el.textContent = msg;
    el.classList.remove('khrl-toast-out');
    void el.offsetWidth;
    el.classList.add('khrl-toast-in');

    clearTimeout(_toastTmr);
    _toastTmr = setTimeout(function () {
      el.classList.remove('khrl-toast-in');
      el.classList.add('khrl-toast-out');
      setTimeout(function () { el.classList.remove('khrl-toast-out'); }, 220);
    }, 1800);
  }

  /* ── Free-shipping progress bar ── */
  function updateBar(subtotalCents) {
    var bar = document.querySelector('[data-khrl-ship-fill]');
    var msg = document.querySelector('[data-khrl-ship-msg]');
    if (!bar || !msg) return;
    if (subtotalCents >= FREE_SHIP_THRESHOLD) {
      bar.style.width = '100%';
      msg.innerHTML   = '<strong>You\'ve unlocked free shipping!</strong>';
    } else {
      var remaining = FREE_SHIP_THRESHOLD - subtotalCents;
      var pct       = Math.min(100, Math.round((subtotalCents / FREE_SHIP_THRESHOLD) * 100));
      bar.style.width = pct + '%';
      msg.innerHTML   = 'Add <strong>₹' + Math.ceil(remaining / 100) + '</strong> more for free shipping';
    }
  }

  /* ── Central reaction fired after any ATC ── */
  function onItemAdded(title, cart) {
    animateCartIcon();
    if (cart) {
      updateBadge(cart.item_count);
      updateBar(cart.items_subtotal_price);
    }
    showCartToast(title ? 'Added: ' + title : 'Added to cart');
  }

  /* ── Custom khrl:atc event (dispatched by our custom ATC sections) ── */
  document.addEventListener('khrl:atc', function (e) {
    var title = e.detail && e.detail.title;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { onItemAdded(title, cart); })
      .catch(function () { onItemAdded(title, null); });
  });

  /* ── Dawn PubSub — native product-form ATC (PDP, collection, related) ── */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
        var cart   = payload && payload.cart;
        var source = payload && payload.source;

        /* Only act on native product-form submissions; other sources just refresh bar */
        if (source !== 'product-form') {
          if (cart) updateBar(cart.items_subtotal_price);
          return;
        }

        var variantId = payload.productVariantId;
        var title = '';
        if (cart && variantId) {
          var items = cart.items || [];
          for (var i = 0; i < items.length; i++) {
            if (String(items[i].variant_id) === String(variantId)) {
              title = items[i].title;
              break;
            }
          }
        }
        onItemAdded(title, cart);
      });
    }

    /* Init shipping bar on page load */
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBar(cart.items_subtotal_price); })
      .catch(function () {});
  });

  /* ── Legacy cart:refresh (keep for third-party compatibility) ── */
  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBar(cart.items_subtotal_price); })
      .catch(function () {});
  });
}());
